export const MAX_PER_PAGE = 25
export const INFINITE_QUERY_KEY = 'infinite'